import React from "react";
import styles from "./index.module.css";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerWrapper}>
                <div className={styles.footerCompanyInfo}>
                    <a href="https://c3ihub.org" target="_blank" className={styles.CompanyImageWrapper}>
                        <img className={styles.footerCompanyLogo} src={`${require("./Images/company.png")}`} alt="" />
                    </a>
                    <p className={styles.footerCompanyDescription}>
                        C3iHub or IHUB NTIHAC FOUNDATION was set up as a Section-8 company (not-for-profit) at lIT Kanpur under the National Mission on Interdisciplinary Cyber-Physical Systems
                        (NM-ICPS), by Department of Science and Technology (DST), Government of India.
                    </p>
                    <div className={styles.social_tags}>
                        <h3>Follow us on</h3>
                        <div>
                            <a href="https://www.facebook.com/C3iHub.org" rel="noopener noreferrer" target="_blank" class="icon" previewlistener="true" style={{ color: "#1877f2" }}>
                                <svg
                                    class="svg-inline--fa fa-facebook brand-item"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="facebook"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path
                                        class=""
                                        fill="currentColor"
                                        d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
                                    ></path>
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/c3ihub/?hl=en" rel="noopener noreferrer" target="_blank" class="icon" previewlistener="true" style={{ color: "#4c68d7" }}>
                                <svg
                                    class="svg-inline--fa fa-instagram brand-item"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="instagram"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                >
                                    <path
                                        class=""
                                        fill="currentColor"
                                        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                                    ></path>
                                </svg>
                            </a>
                            <a href="https://www.linkedin.com/company/c3i-hub/" rel="noopener noreferrer" target="_blank" class="icon" previewlistener="true" style={{ color: "#0077b5" }}>
                                <svg
                                    class="svg-inline--fa fa-linkedin brand-item"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="linkedin"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                >
                                    <path
                                        class=""
                                        fill="currentColor"
                                        d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                                    ></path>
                                </svg>
                            </a>
                            <a href="https://twitter.com/hubc3i?lang=en" rel="noopener noreferrer" target="_blank" class="icon" previewlistener="true" style={{ color: "#1da1f2" }}>
                                <svg
                                    class="svg-inline--fa fa-x-twitter brand-item"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="x-twitter"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path
                                        class=""
                                        fill="currentColor"
                                        d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                                    ></path>
                                </svg>
                            </a>
                            <a href="https://www.youtube.com/@C3iHub" rel="noopener noreferrer" target="_blank" class="icon" previewlistener="true" style={{ color: "#ff0000" }}>
                                <svg
                                    class="svg-inline--fa fa-youtube brand-item"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="youtube"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                >
                                    <path
                                        class=""
                                        fill="currentColor"
                                        d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                                    ></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div className={styles.footerConferenceInfo}>
                    <h2>About Workshop</h2>
                    <div className={styles.linksWrapper}>
                        <a className={styles.links} href="/aicctp/#home">
                            Home
                        </a>
                        <a className={styles.links} href="/aicctp/#speakers">
                            Speakers
                        </a>
                        <a className={styles.links} href="/aicctp/#team">
                            Team
                        </a>
                        <a className={styles.links} href="/aicctp/#schedule">
                            Schedule
                        </a>
                        <a className={styles.links} href="/aicctp/#sponsors">
                            Sponsors
                        </a>
                    </div>
                </div>
                <div className={styles.footerContactInfo}>
                    <h2>Contact Us</h2>
                    <p>workshop@c3ihub.iitk.ac.in</p>
                    <p>C3iHub, 2nd Floor, Technopark Phase I, IIT Kanpur</p>
                    <p>Kanpur - 208016</p>
                    <p>Uttar Pradesh, India</p>
                </div>
            </div>
            <p className={styles.text}>&copy; {new Date().getFullYear()} C3ihub.org. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
